import { ConfigService } from '@nuskin/ns-util';
export default {
    methods: {
        getClientId() {
            const marketConfig = ConfigService.getMarketConfig(true, this.country);
            return marketConfig && marketConfig.checkout ? marketConfig.checkout.clientId : null;
        },
    },
}